import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CardHeader, Paper, IconButton, Typography } from '@material-ui/core';
import IconClose from '@material-ui/icons/Close'
import PropTypes from 'prop-types';

const ModalWrap = ({ title, closeModal, rightComponent }) => {
    const useStyles = React.useCallback(makeStyles((theme) => ({
        root: {
            backgroundColor: theme.palette.app.primary,
            position: 'sticky',
            top: 0,
            zIndex: 2,
            borderRadius: 0
        },
        headerAction: {
            marginTop: 0,
            marginBottom: 0
        },
        cardHeader: {
            backgroundColor: theme.palette.app.primary
        },
        headerTitle: {
            color: 'white',
            fontSize: 18,
            lineHeight: '22px'
        },
        title: {
            color: 'white',
            fontSize: 18,
            lineHeight: '22px'
        }
    })), []);
    const classes = useStyles();

    return (
        <Paper className={classes.root}>
            <CardHeader
                className={classes.cardHeader}
                action={
                    <div style={{ display: 'flex' }}>
                        {rightComponent}
                        <IconButton aria-label="close" onClick={closeModal} style={{ padding: 8 }}>
                            <IconClose style={{ fill: 'white' }} />
                        </IconButton>
                    </div>
                }
                title={<Typography className={classes.title}>{title}</Typography>}
                classes={{ action: classes.headerAction }}
            />
        </Paper >
    );
};
ModalWrap.propTypes = {
    title: PropTypes.string,
    closeModal: PropTypes.func,
    rightComponent: PropTypes.any
};
export default ModalWrap;
